import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";

import colors from "../../colors";
import CabinetPage from "../../components/Common/CabinetPage";
import CreateMeetingButton from "../../components/Schedule/CreateMeetingButton/CreateMeetingButton";
import MeetingLogContainer from "../../components/Schedule/MeetingLog";
import { isLargeFormatDevice } from "../../utils/screenSizeUtils";

const RecurringMeetingLog = (): ReactElement => {
  return (
    <CabinetPage
      pageName="Meetings"
      headerContent={<Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          paddingLeft: 2,
        }}>
        <Typography variant="h1">
          Recurring Meetings
        </Typography>
        {isLargeFormatDevice() && (
          <CreateMeetingButton buttonTitle="Create" />
        )}
      </Box>
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: 5,
          paddingTop: 4,
        }}>
        <Typography variant="h2" color={colors.black600} sx={{
          fontWeight: "regular",
        }}>
          Access or update the Recurring Meetings you've prepared.
        </Typography>

        <MeetingLogContainer recurring />
      </Box>
    </CabinetPage>
  );
};

export default RecurringMeetingLog;
